import IVendorConfig from "src/environments/Ivendor-config";

export function vivacityMapper(config: IVendorConfig) {
  config.primaryUseOptionsToDisplay = ["Education"];
}
